/**
 * ru-word.js — клиент GET /api/ru-word: одно русское слово для человека — все
 * ударения с источником, разборы pymorphy и строки орфоэпического списка ФИПИ
 * (RuWordController → демон Silero `readings()`, те же слои, что у голосов).
 *
 * Один клиент на все страницы, которые показывают слово (/foneticheskij-razbor,
 * карточка слова на /russian-stress): адрес, кэш и отказ живут здесь, а не в
 * каждой странице своим fetch.
 *
 *   RuWord.get(word, {url}) → Promise<{word, readings:[{form, source}], morph, exam}>
 *
 * Отказ — Error с `.status`: 404 — на этом домене сервиса нет, 422 — это не одно
 * русское слово, 502/503 — демон недоступен, 0 — сеть. Удачный ответ живёт в
 * памяти страницы; неудачный не кэшируется. Регистр слова сохраняется: «Паша» с
 * заглавной — имя, «паша» — титул (слой имён решает по заглавной букве).
 */
(function (root) {
    'use strict';

    var cache = Object.create(null);

    function get(word, opts) {
        opts = opts || {};
        var w = String(word == null ? '' : word).trim();
        var url = (opts.url || '/api/ru-word') + '?w=' + encodeURIComponent(w);
        if (cache[url]) return cache[url];
        var p = Promise.resolve().then(function () {
            return fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        }).then(function (r) {
            if (!r.ok) { var e = new Error('ru-word ' + r.status); e.status = r.status; throw e; }
            return r.json();
        }, function (err) {
            var e = new Error('ru-word network: ' + (err && err.message)); e.status = 0; throw e;
        });
        cache[url] = p;
        p.catch(function () { delete cache[url]; });
        return p;
    }

    var api = { get: get };
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    if (typeof window !== 'undefined') window.RuWord = api;
})(this);
